import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styles: [
  ]
})
export class NotifyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
